import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { IPaginatedResponse } from '@boma/client-shared';
import { IProduct } from '@boma/supplier-portal/shared/entities';
import { CatalogueService } from '@boma/supplier-portal/shared/services';
import { AutoComplete } from 'primeng/autocomplete';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'boma-product-selector',
  templateUrl: './product-selector.component.html',
  styleUrls: ['./product-selector.component.scss'],
})
export class ProductSelectorComponent implements OnInit {
  selectedProductsIds: string[] = [];
  selectedEntityId = '';
  selectedLocationIds: string[] = [];
  searchSubscription: Subscription;
  productSearchResults: IPaginatedResponse<IProduct>;
  productSearchSubject = new Subject<string>();
  page = '1';
  itemsPerPage = 500; // obviously this is not great improve like locations
  searchTerm = '';
  searching = false;
  searched = false;
  @Input() showLabels = false;
  @Input() enableFilter = false;

  paginationData: {
    totalItems: number;
    totalPages: number;
    previousPage: number;
    nextPage: number;
  };

  @Input() multipleProducts = true;
  @Input() requireSelection = false;
  @Input() selectedProduct;
  @Input() selectedProducts;
  @Input() placeHolderText = 'All Products';
  @Input() organisation;
  @Output() selectedProductsChange = new EventEmitter<IProduct[]>();
  @ViewChild('productSearch') productSearchField: AutoComplete;

  constructor(private catalogueService: CatalogueService) {}
  // TODO ADD PROPER SEARCHING AND PAGINATION
  ngOnInit(): void {
    this.searchSubscription = this.productSearchSubject
      .asObservable()
      .pipe(
        tap((x) => {
          this.searching = true;
        }),
        debounceTime(500),
        switchMap((searchTerm) => {
          const location =
            this.selectedLocationIds?.length > 1
              ? '' //get all the locations products if multiple locations selected
              : this.selectedLocationIds[0];
          return this.catalogueService.loadCatalogue(
            this.organisation?.id ?? this.organisation,
            location,
            this.page,
            this.itemsPerPage.toString(),
            searchTerm
          );
        })
      )
      .subscribe((res) => {
        this.productSearchResults = res;
        this.searching = false;
        this.searched = true;
        this.paginationData = {
          totalItems: res.totalItems,
          totalPages: res.totalPages,
          previousPage: res.previousPage,
          nextPage: res.nextPage,
        };
      });
    this.productSearchSubject.next(''); // kick it off I mean not really ideal....
  }

  searchProduct(event) {
    if (this.productSearchResults) return; // we have results dont load again TODO (this will need to be adjsuted when we have more than 1000)
    const query = event?.query || event || '';
    this.searchTerm = query;
    this.productSearchSubject.next(query);
  }

  handleSelectedProducts(ev) {
    if (!this.multipleProducts) {
      this.selectedProducts = [ev.value];
    }
    this.selectedProductsChange.emit(this.selectedProducts);
  }
}
